// Traducciones en English
export default {
  // General
  appName: 'TorneosPro',
  loading: 'Loading...',
  save: 'Save',
  cancel: 'Cancel',
  edit: 'Edit',
  delete: 'Delete',
  create: 'Create',
  add: 'Add',
  new: 'New',
  search: 'Search',
  searchTeam: 'Search team...',
  searching: 'Searching',
  noResultsFound: 'No results found',
  filter: 'Filter',
  all: 'All',
  active: 'Active',
  inactive: 'Inactive',
  yes: 'Yes',
  no: 'No',
  name: 'Name',
  description: 'Description',
  status: 'Status',
  actions: 'Actions',
  details: 'Details',
  back: 'Back',
  next: 'Next',
  previous: 'Previous',
  close: 'Close',
  confirm: 'Confirm',
  optional: 'Optional',
  required: 'Required',
  language: 'Language',
  share: 'Share',
  copy: 'Copy',
  copied: 'Copied',
  linkCopied: 'Link copied',

  // Errores y mensajes
  error: 'Error',
  success: 'Success',
  warning: 'Warning',
  info: 'Information',
  errorLoading: 'Error loading data',
  errorSaving: 'Error saving',
  errorDeleting: 'Error deleting',
  savedSuccess: 'Saved successfully',
  deletedSuccess: 'Deleted successfully',
  createdSuccess: 'Created successfully',
  updatedSuccess: 'Updated successfully',
  confirmDelete: 'Are you sure you want to delete this item?',
  confirmDeleteTournament: 'Delete tournament',
  deleteTournamentWarning: 'ALL teams, players, matches and events will be deleted. This action cannot be undone.',
  tournamentDeletedCompletely: 'Tournament and all its data deleted successfully',
  noResults: 'No results found',
  requiredFields: 'Please fill in all required fields',

  // Auth
  login: 'Log in',
  logout: 'Log out',
  loginWithGoogle: 'Sign in with Google',
  welcomeBack: 'Welcome back',
  accessDenied: 'Access denied',
  notApproved: 'Your account has not been approved yet',
  contactAdmin: 'Contact the administrator',

  // Navegación
  dashboard: 'Dashboard',
  organizations: 'Organizations',
  tournaments: 'Tournaments',
  teams: 'Teams',
  players: 'Players',
  matches: 'Matches',
  forms: 'Registrations',
  users: 'Users',
  system: 'System',
  settings: 'Settings',
  publicView: 'Public view',
  adminPanel: 'Admin Panel',
  home: 'Home',
  welcome: 'Welcome',
  managePlayers: 'Manage players',
  manageTournaments: 'Manage tournaments',
  manageTeams: 'Manage teams',
  manageOrganizations: 'Manage organizations',
  manageMatches: 'Manage matches',
  manageUsers: 'Manage users',
  allTournaments: 'All tournaments',
  allTeams: 'All teams',

  // Dashboard
  welcomeMessage: 'Welcome to the admin panel',
  quickStats: 'Quick stats',
  recentActivity: 'Recent activity',
  recentResults: 'Recent results',
  upcomingMatches: 'Upcoming matches',
  todayMatches: "Today's matches",

  // Organizaciones
  organization: 'Organization',
  newOrganization: 'New Organization',
  editOrganization: 'Edit Organization',
  noOrganizations: 'No organizations',
  createFirstOrg: 'Create your first organization to get started',
  orgNamePlaceholder: 'Organization name',
  orgDescPlaceholder: 'Brief description',
  allOrganizations: 'All organizations',

  // Generation confirmations
  generateCalendarMessage: 'Generate match calendar? This may overwrite existing matches.',
  generateKnockoutMessage: 'Generate knockout with qualified teams?',
  deleteEventConfirmMessage: 'Delete this event from the match?',

  // Torneos
  tournament: 'Tournament',
  newTournament: 'New Tournament',
  editTournament: 'Edit Tournament',
  noTournaments: 'No tournaments',
  createFirstTournament: 'Create your first tournament',
  statusUpcoming: 'Upcoming',
  statusOngoing: 'Ongoing',
  statusFinished: 'Finished',
  tournamentName: 'Tournament name',
  tournamentFormat: 'Format',
  league: 'League',
  cup: 'Cup',
  groups: 'Groups',
  startDate: 'Start date',
  endDate: 'End date',
  registrationOpen: 'Registration open',
  sport: 'Sport',
  selectSport: 'Select sport',
  selectOrganization: 'Select organization',
  selectTournament: 'Select tournament',
  season: 'Season',
  pointsWin: 'Points for win',
  pointsDraw: 'Points for draw',
  pointsLoss: 'Points for loss',

  // Equipos
  team: 'Team',
  newTeam: 'New Team',
  editTeam: 'Edit Team',
  noTeams: 'No teams',
  createFirstTeam: 'Add the first team to the tournament',
  teamName: 'Team name',
  shortName: 'Short name',
  teamColor: 'Team color',
  logo: 'Logo',
  group: 'Group',
  contact: 'Contact',
  phone: 'Phone',

  // Jugadores
  player: 'Player',
  newPlayer: 'New Player',
  editPlayer: 'Edit Player',
  noPlayers: 'No players',
  createFirstPlayer: 'Add the first player',
  playerName: 'Player name',
  number: 'Number',
  position: 'Position',
  selectTeam: 'Select team',
  goals: 'Goals',
  assists: 'Assists',
  yellowCards: 'Yellow cards',
  redCards: 'Red cards',
  suspended: 'Suspended',
  suspendedMatches: 'Suspension matches',

  // Posiciones
  goalkeeper: 'Goalkeeper',
  defender: 'Defender',
  midfielder: 'Midfielder',
  forward: 'Forward',

  // Partidos
  match: 'Match',
  newMatch: 'New Match',
  editMatch: 'Edit Match',
  noMatches: 'No matches',
  createFirstMatch: 'Create the first match',
  homeTeam: 'Home team',
  awayTeam: 'Away team',
  dateTime: 'Date and time',
  location: 'Location',
  round: 'Matchday',
  referee: 'Referee',
  result: 'Result',
  enterResult: 'Enter Result',
  scheduled: 'Scheduled',
  live: 'Live',
  finished: 'Finished',
  postponed: 'Postponed',
  cancelled: 'Cancelled',
  vs: 'vs',
  generateCalendar: 'Generate Calendar',
  clearCalendar: 'Clear Calendar',

  // Tipos de resultado
  resultIn: 'Result in',
  regularTime: 'Regular time',
  overtime: 'Overtime',
  penalties: 'Penalties',
  penaltiesResult: 'Penalties result',

  // Clasificación
  standings: 'Standings',
  played: 'Played',
  won: 'W',
  drawn: 'D',
  lost: 'L',
  goalsFor: 'GF',
  goalsAgainst: 'GA',
  goalDifference: 'GD',
  points: 'Pts',

  // Usuarios
  user: 'User',
  newUser: 'New User',
  editUser: 'Edit User',
  noUsers: 'No users',
  email: 'Email',
  role: 'Role',
  admin: 'Administrator',
  editor: 'Editor',
  viewer: 'Viewer',
  approved: 'Approved',
  pending: 'Pending',
  assignOrganizations: 'Assign organizations',

  // Público
  selectSportTitle: 'Select a sport',
  availableTournaments: 'Available tournaments',
  noActiveTournaments: 'No active tournaments',
  viewTournament: 'View tournament',
  calendar: 'Calendar',
  results: 'Results',

  // Deportes
  football: 'Football',
  basketball: 'Basketball',
  volleyball: 'Volleyball',
  tennis: 'Tennis',
  handball: 'Handball',
  hockey: 'Hockey',
  rugby: 'Rugby',
  baseball: 'Baseball',
  futsal: 'Futsal',
  football7: '7-a-side Football',
  football11: 'Football',
  pelota: 'Pelota',
  beach: 'Beach Soccer',
  beachVolley: 'Beach Volleyball',
  beachSoccer: 'Beach Soccer',
  padel: 'Padel',
  tableTennis: 'Table Tennis',
  badminton: 'Badminton',
  waterpolo: 'Water Polo',
  fieldhockey: 'Field Hockey',
  americanFootball: 'American Football',
  cricket: 'Cricket',
  rowing: 'Rowing',
  swimming: 'Swimming',
  cycling: 'Cycling',
  athletics: 'Athletics',
  gymnastics: 'Gymnastics',
  boxing: 'Boxing',
  wrestling: 'Wrestling',
  judo: 'Judo',
  karate: 'Karate',
  taekwondo: 'Taekwondo',
  fencing: 'Fencing',
  archery: 'Archery',
  shooting: 'Shooting',
  equestrian: 'Equestrian',
  golf: 'Golf',
  sailing: 'Sailing',
  canoeing: 'Canoeing',
  surfing: 'Surfing',
  skateboarding: 'Skateboarding',
  climbing: 'Climbing',
  skiing: 'Skiing',
  icehockey: 'Ice Hockey',
  figureskating: 'Figure Skating',
  curling: 'Curling',
  bobsled: 'Bobsled',
  biathlon: 'Biathlon',
  esports: 'eSports',
  chess: 'Chess',
  darts: 'Darts',
  billiards: 'Billiards',
  bowling: 'Bowling',
  pelotaVasca: 'Basque Pelota',

  // Configuración de desempate
  tiebreaker: 'Tiebreaker',
  tiebreakerCriteria: 'Tiebreaker criteria',
  headToHead: 'Head to head',
  goalDiff: 'Goal difference',
  goalsScored: 'Goals scored',
  awayGoals: 'Away goals',

  // Estadísticas
  stats: 'Statistics',
  totalGoals: 'Total goals',
  avgGoals: 'Average goals',
  cleanSheets: 'Clean sheets',

  // Tiempo
  today: 'Today',
  tomorrow: 'Tomorrow',
  yesterday: 'Yesterday',
  thisWeek: 'This week',
  nextWeek: 'Next week',

  // Acciones rápidas
  quickAdd: 'Quick add',
  quickAddTeams: 'Add multiple teams',
  quickAddPlayers: 'Add multiple players',
  teamsPlaceholder: 'One team per line...\n\nExample:\nManchester United\nLiverpool\nChelsea',
  playersPlaceholder: 'One player per line (name or name, number)...\n\nExample:\nMessi, 10\nRonaldo, 7\nBenzema',
  linesProcessed: 'lines processed',
  teamsCreated: 'teams created',
  playersCreated: 'players created',

  // Calendario
  calendarSettings: 'Calendar Settings',
  calendarFormat: 'Format',
  roundRobin: 'League (round robin)',
  knockout: 'Knockout',
  singleRound: 'Single round',
  doubleRound: 'Home and away',
  groupsKnockout: 'Groups + Knockout',
  shuffleTeams: 'Shuffle matchups',
  thirdPlaceMatch: 'Third place match',
  knockoutBracketInfo: 'A bracket will be generated for {teams} teams',
  numberOfGroups: 'Number of groups',
  qualifiedPerGroup: 'Qualified per group',
  doubleRoundGroups: 'Double round in groups',
  qualified: 'Qualified',
  generateKnockout: 'Generate Knockout',
  scheduleSettings: 'Schedule settings',
  knockoutMatchesGenerated: 'knockout matches generated',
  confirmGenerateKnockout: 'Generate knockout matches with qualified teams?',
  notEnoughQualified: 'Not enough qualified teams',
  final: 'Final',
  semifinal: 'Semi Final',
  cuartos: 'Quarter Finals',
  octavos: 'Round of 16',
  dieciseisavos: 'Round of 32',
  tercer_puesto: 'Third Place',
  bracket: 'Bracket',
  groupPhase: 'Group Phase',
  knockoutPhase: 'Knockout Phase',
  winner: 'Winner',
  vsShort: 'vs',
  matchOrder: 'Match order',
  randomOrder: 'Random',
  registrationOrder: 'Registration order',
  daysBetweenRounds: 'Days between rounds',
  defaultTime: 'Default time',
  defaultLocation: 'Default location',
  deleteExisting: 'Delete existing matches',
  deleteExistingHint: 'All tournament matches will be deleted before generating new ones',
  generate: 'Generate',
  matchesGenerated: 'matches generated',
  needTwoTeams: 'You need at least 2 teams',
  selectTournamentFirst: 'Select a tournament first',
  selectTeamFirst: 'Select a team first',
  confirmGenerate: 'Generate calendar? This action cannot be undone.',
  roundN: 'Matchday',

  // Goleadores y eventos
  scorer: 'Scorer',
  assistant: 'Assist by',
  minute: 'Minute',
  ownGoal: 'Own goal',
  penalty: 'Penalty',
  noEvents: 'No events recorded',
  topScorers: 'Top scorers',
  topAssisters: 'Top assisters',

  // Additional translations
  activeTournaments: 'Active tournaments',
  addGoal: 'Add goal',
  addPlayersToTeam: 'Add players to team',
  allowDraw: 'Allow draw',
  allowDrawHint: 'If disabled, matches must have a winner',
  approve: 'Approve',
  approvedSuccess: 'User approved successfully',
  authorizedOnly: 'Authorized users only',
  awayGoalsHint: 'Away goals in case of tie',
  awayGoalsRule: 'Away goals rule',
  cards: 'Cards',
  color: 'Color',
  confirmDeleteMatch: 'Delete this match?',
  confirmDeleteOrg: 'Delete this organization?',
  confirmDeletePlayer: 'Delete this player?',
  confirmDeleteTeam: 'Delete this team?',
  confirmDeleteUser: 'Delete this user?',
  continueWith: 'Continue with',
  createFirstOrganization: 'Create your first organization',
  createFirstUser: 'Create the first user',
  delegateName: 'Delegate name',
  emailAndNameRequired: 'Email and name are required',
  emailExists: 'This email is already registered',
  fillAllFields: 'Fill in all required fields',
  fiveSets: 'Five sets',
  format: 'Format',
  fourQuarters: 'Four quarters',
  fullName: 'Full name',
  knockoutSettings: 'Knockout settings',
  loginError: 'Login error',
  lossInOvertime: 'Loss in overtime',
  lossInPenalties: 'Loss in penalties',
  matchDuration: 'Match duration',
  matchEvents: 'Match events',
  matchSettings: 'Match settings',
  matchday: 'Round',
  minutes: 'minutes',
  nameAndTeamRequired: 'Name and team are required',
  nameRequired: 'Name is required',
  noAccount: "Don't have an account?",
  noCards: 'No cards',
  noCardsYet: 'No cards recorded yet',
  noGoalsYet: 'No goals recorded yet',
  noMatchesScheduled: 'No matches scheduled',
  noPermissionSection: 'You do not have permission to view this section',
  noScorers: 'No scorers',
  noTeamsInTournament: 'No teams in this tournament',
  none: 'None',
  organizationName: 'Organization name',
  overtimeAvailable: 'Overtime available',
  overtimeDuration: 'Overtime duration',
  overtimePenalties: 'Overtime and penalties',
  password: 'Password',
  passwordRequired: 'Password is required',
  passwordTooShort: 'Password must be at least 6 characters',
  passwordHint: 'User will use this password to access',
  leaveEmptyToKeep: 'Leave empty to keep',
  userCreatedSuccess: 'User created successfully',
  accountActivated: 'Account activated successfully',
  penaltiesAvailable: 'Penalties available',
  pendingApproval: 'Pending approval',
  pendingInvitations: 'Pending invitations',
  invited: 'Invited',
  invitationCreated: 'Invitation created successfully',
  inviteUser: 'Invite user',
  sendInvitation: 'Send invitation',
  inviteUserHint: 'User will be able to access when they register with this email',
  optionalName: 'Name (optional)',
  emailRequired: 'Email is required',
  waitingRegistration: 'Waiting for registration',
  pendingRequests: 'Pending requests',
  periods: 'Periods',
  pivot: 'Pivot',
  reject: 'Reject',
  rejectedSuccess: 'User rejected',
  scoring: 'Scoring',
  select: 'Select',
  selectTeamOrAddPlayers: 'Select a team or add players',
  sessionStarted: 'Session started',
  squad: 'Squad',
  statistics: 'Statistics',
  threePeriods: 'Three periods',
  tournamentActive: 'Tournament active',
  tournamentConfig: 'Tournament configuration',
  tournamentDescription: 'Tournament description',
  twoLegs: 'Two legs',
  twoPeriods: 'Two halves',
  universal: 'Universal',
  unspecified: 'Unspecified',
  userActive: 'User active',
  userCanAccess: 'User can access',
  userNotFound: 'User not found',
  winInOvertime: 'Win in overtime',
  winInPenalties: 'Win in penalties',
  winger: 'Winger',
  wrongPassword: 'Wrong password',

  // Cards
  yellowCard: 'Yellow card',
  redCard: 'Red card',
  secondYellow: 'Second yellow',
  addCard: 'Add card',
  cardType: 'Card type',
  cardsReceived: 'Cards received',
  suspendedPlayers: 'Suspended players',
  accumulatedCards: 'Accumulated cards',
  sanctionLimit: 'Sanction limit',
  matchesSuspended: 'Suspension matches',

  // Logos de equipo (crest). Los del torneo/org viven más abajo.
  teamLogo: 'Team logo',
  uploadTeamLogo: 'Upload crest',
  changeTeamLogo: 'Change crest',
  removeLogo: 'Remove logo',
  logoUploaded: 'Logo uploaded successfully',
  logoRemoved: 'Logo removed',
  invalidImageFormat: 'Invalid image format',
  imageTooLarge: 'Image is too large (max. 2MB)',

  // Público
  publicSubtitle: 'Sports tournament management',
  chooseSport: 'Choose a sport',
  activeSports: 'Sports with active tournaments',
  allSports: 'Other sports',
  checkBackLater: 'Check back soon for available tournaments',
  tournamentsCount: 'tournaments',
  noUpcomingMatches: 'No upcoming matches',
  noRecentResults: 'No recent results',
  selectTournamentHint: 'Select a tournament to see more details',
  noDescription: 'No description',
  standingsTab: 'Standings',
  matchesTab: 'Matches',
  scorers: 'Scorers',
  teamsTab: 'Teams',
  shareText: 'Check out the {name} tournament!',
  noMatchesYet: 'No matches scheduled yet',
  noTeamsYet: 'No teams registered yet',
  roundLabel: 'Matchday',
  groupLabel: 'Group',

  sports: 'Sports',
  openRegistrations: 'Open registrations',
  noOpenRegistrations: 'No open registrations',
  signUp: 'Sign up',
  registrations: 'Registrations',
  groupPhaseLabel: 'Group stage',
  knockoutPhaseLabel: 'Knockout stage',
  mvpTitle: 'Most Valuable Player',
  mvpScoring: 'MVP scoring: Score = 3pts | Assist = 2pts | Yellow = -1pt | Red = -3pts',
  noMvpData: 'Not enough data yet',
  noAssistsYetFull: 'No assists registered yet',
  assistsShort: 'ast.',
  formNotFound: 'Form not found',
  formLoadError: 'Error loading form',
  teamNameRequired: 'Team name is required',
  contactNameRequired: 'Contact name is required',
  addAtLeastOnePlayer: 'Add at least one player',
  checkCaptcha: 'Check the "I\'m not a robot" box',
  submitError: 'Error submitting registration. Please try again.',
  goHome: 'Go home',
  registrationsClosed: 'Registrations closed',
  registrationDeadlinePassed: 'The registration period for this tournament has ended.',
  deadlineExpired: 'Deadline expired',
  deadlineExpiredMsg: 'The registration deadline has passed.',
  registrationSent: 'Registration sent',
  registrationConfirmMsg: 'The organizer will review your registration and contact you.',
  shareRegistration: 'Share registration',
  closingSoon: 'Closing soon',
  closingIn: 'Registration closes in',
  days: 'days',
  hours: 'hours',
  min: 'min',
  sec: 'sec',
  registrationForm: 'Registration form',
  teamNameLabel: 'Team name',
  teamNamePlaceholder: 'Your team name',
  contactNameLabel: 'Contact / Manager name',
  contactNamePlaceholder: 'Your full name',
  // phone/playerName already declared above.
  emailLabel: 'Email',
  playersMax: 'Players (max. {max})',
  positionLabel: 'Position',
  posGoalkeeper: 'Goalkeeper',
  posDefender: 'Defender',
  posWinger: 'Winger',
  posPivot: 'Pivot',
  posUniversal: 'Universal',
  playersHint: 'Only fill in confirmed players. You can leave empty rows.',
  commentsLabel: 'Comments / Notes',
  commentsPlaceholder: 'Any additional information...',
  sending: 'Sending...',
  sendRegistration: 'Send registration',
  shareBtn: 'Share',
  // Public registration — player fields / messages / table headers
  playerLastName: 'Last name',
  playerDni: 'ID / Passport',
  playerBirthDate: 'Date of birth',
  playerBirthDateShort: 'Birth date',
  playerNumber: 'Number',
  playerSize: 'Size',
  playerEmail: 'Email',
  playerPhone: 'Phone',
  playerN: 'PLAYER',
  playersTitle: 'Players',
  playersTitleMinMax: 'min. {min}, max. {max}',
  playersTitleMax: 'max. {max}',
  phoneRequired: 'Phone is required',
  // emailRequired already declared above.
  minPlayersError: 'You must register at least {min} players. You have filled in {filled}.',
  missingFieldOfPlayer: 'Missing {field} for player {n}',
  playerValidationPrefix: 'Player {n}',
  vName: 'the name',
  vLastName: 'the last name',
  vDni: 'the ID/Passport',
  vBirthDate: 'the date of birth',
  vNumber: 'the number',
  vPosition: 'the position',
  vSize: 'the size',
  vEmail: 'the email',
  vPhone: 'the phone',
  dniLetterError: 'The letter of ID {value} is not correct (should be {expected})',
  nieLetterError: 'The letter of NIE {value} is not correct (should be {expected})',
  inscriptionsNotInPlan: 'Online registrations are not available for this tournament. Please contact the organization directly.',
  captchaServerFailed: 'Security verification failed. Tick the "I\'m not a robot" box again and resubmit.',
  deadlinePassedError: 'The registration deadline has passed.',
  tooManyAttempts: 'You have submitted too many registrations recently with this email. Please try again later.',
  formNotFoundReload: 'The form is no longer available. Please reload the page.',
  submitErrorRetry: 'Tick the captcha again and retry.',
  waitlistTitle: 'You are on the waiting list',
  waitlistMessage: 'The spots for "{title}" were already full, but your team "{team}" has been placed on the waiting list. We will notify you if any spot becomes available.',
  registrationSentMessage: 'Your team "{team}" has been successfully registered in "{title}".',
  backToTournaments: 'Back to tournaments',
  backShort: 'Back',
  seatsFull: 'Spots full ({current}/{max})',
  seatsCounter: '{current} of {max} spots — {remaining} remaining',
  waitlistNote: 'If you register now, you will be placed on the waiting list.',
  whatsappShareText: 'We have registered for {title}! 🏆\n\nRegister too:\n{url}',
  captchaLoadFailed: 'Could not load the security verification (it may be your network or a browser extension). Try reloading the page or contact the tournament organization directly.',
  legalConsentText: 'By submitting this form you accept that the data provided (including the team name) will be reviewed by the tournament organization and may be published on the web. TorneosPro acts solely as a technology platform and is not responsible for the content entered by users nor for the decisions of the organization. See our',
  privacyPolicyLink: 'privacy policy',
  phonePlaceholder: '600 000 000',
  emailPlaceholderExample: 'you@email.com',
  privacyPolicy: 'Privacy Policy',
  legalNotice: 'Legal Notice',
  cookiePolicy: 'Cookie Policy',
  privacy: 'Privacy',
  legalShort: 'Legal notice',
  cookies: 'Cookies',

  // Admin - Tournaments
  onlyImagesAllowed: 'Only images are allowed',
  imageMaxSize500: 'Image cannot exceed 500KB',
  tournamentLogo: 'Tournament logo',
  changeLogo: 'Change logo',
  uploadLogo: 'Upload logo',
  removeLogoBtn: 'Remove logo',
  tiebreakerTab: 'Tiebreakers',
  visibilityTab: 'Visibility',
  tiebreakerHint: 'Order of criteria when two teams are tied on points. The first one has priority.',
  tbPoints: 'Points',
  tbHeadToHead: 'Head to head',
  tbGoalDifference: 'Goal difference',
  tbGoalsFor: 'Goals for',
  tbGoalsAgainst: 'Goals against',
  tbWins: 'Wins',
  tbLosses: 'Losses (fewer = better)',
  tbPointsDifference: 'Points difference',
  tbPointsFor: 'Points for',
  tbSetsDifference: 'Sets difference',
  tbSetsFor: 'Sets won',
  tbRandom: 'Random draw',
  tbLossesShort: 'Losses',
  tbPointsDifferenceShort: 'Pts diff',
  tbSetsDifferenceShort: 'Sets diff',
  tbRandomShort: 'Draw',
  addCriterion: 'Add criterion:',
  visibilityHint: 'Choose which sections are shown in the tournament public view.',
  visTabStandings: 'Standings',
  visTabGroups: 'Groups',
  visTabBracket: 'Bracket',
  visTabMatches: 'Matches',
  visTabScorers: 'Top scorers',
  visTabAssists: 'Assists',
  visTabMvp: 'MVP',
  visTabFairplay: 'Fair Play',
  visTabTeams: 'Teams',
  notAvailableFormat: '(not available in this format)',

  // Admin - Teams
  selectTournamentFirstMsg: 'Select a tournament first',
  needTwoTeamsMsg: 'You need at least 2 teams',
  maxEightGroups: 'Maximum 8 groups',
  groupsSavedOk: 'Groups saved successfully',
  selectTargetTournament: 'Select target tournament',
  selectAtLeastOneTeam: 'Select at least one team',
  teamsImportedWithPlayers: 'teams imported with their players',
  importPartialPlayersWarning: 'Warning: some players could not be copied. The teams were imported successfully.',
  importNoPlayersFound: 'The teams in the source tournament had no players to copy.',
  importBtn: 'Import',
  groupsBtn: 'Groups',
  groupsLabel2: 'Groups: ',
  deleteGroupTitle: 'Delete group',
  removeFromGroupTitle: 'Remove from group',
  importTeamsFromTournament: 'Import teams from another tournament',
  teamsLowercase: 'teams',
  deselectAll: 'Deselect all',
  selectAll: 'Select all',

  // Admin - Players
  bulkPlayersPlaceholder: 'John Smith, 7, Goalkeeper\nPeter Lopez, 10, Wing\nCarl Ruiz, 5\nMike Torres',
  bulkPlayersFormat: 'Format: Name, Number, Position (number and position are optional)',

  // Admin - Matches
  generateKnockoutTitle: 'Generate knockout',
  generateKnockoutMsg: 'Knockout stage will be generated with',
  qualifiedTeamsText: 'qualified teams',
  perGroupText: 'per group',
  generateBtn: 'Generate',

  // Admin - Users / Mesa
  pinCodeLabel: 'PIN code',
  pinCopied: 'PIN copied',
  regeneratePin: 'Regenerate',
  mesaUrlHint: 'The scoring table enters that URL and types this PIN code.',
  mesaWhatsappPrefix: 'Match table - ',
  mesaWhatsappEnter: 'Enter: torneospro.com/#/mesa',
  mesaWhatsappPin: 'PIN code: ',
  copyWhatsappData: 'Copy data for WhatsApp',

  // Admin - Forms
  deleteFormTitle: 'Delete form',
  createTeamFromRegistration: 'Create team from registration',
  deleteRegistrationTitle: 'Delete registration',
  registrationDeleted: 'Registration deleted',
  changeImage: 'Change image',
  uploadImage: 'Upload image',
  deleteBtn: 'Delete',
  registrationReceivedAt: 'Registration received: ',

  // Admin - Settings
  configSaved: 'Configuration saved',
  configTitle: 'Configuration',
  configSubtitle: 'General platform settings',
  visibleSportsTitle: 'Sports visible on public home',
  visibleSportsHint: 'Select which sports are shown on the public home page. Unchecked sports will not appear even if they have tournaments.',

  // Admin - System
  repairProblem: 'Repair problem',
  deleteOrphanEvent: 'Delete this orphan event?',
  deleteProblemDoc: 'Delete the problem document from',
  repairAll: 'Repair all',
  willDeleteDocs: 'Will delete',
  docsWithProblems: 'documents with problems. Continue?',
  backupDownloaded: 'Backup downloaded',
  resetTournamentTitle: 'Reset tournament',
  resetTournamentMsg: 'ALL results, events and matches will be deleted from',
  resetTournamentKeep: 'Teams and players will be kept. Continue?',
  maintenanceOn: 'Maintenance mode enabled',
  maintenanceOff: 'Maintenance mode disabled',
  systemSubtitle: 'Maintenance and diagnostic tools',
  systemTabHealth: 'Health',
  systemTabErrors: 'Errors',
  systemTabBackup: 'Backup',
  systemTabTools: 'Tools',
  systemTabMaintenance: 'Maintenance',
  scanning: 'Scanning...',
  scan: 'Scan',
  pressScanHint: 'Press "Scan" to review the database',
  noErrorsPending: 'No unresolved errors',
  backupHint: 'Download a complete copy of all platform data in JSON format.',
  exporting: 'Exporting...',
  downloadFullBackup: 'Download full backup',
  backupIncludes: 'Includes: tournaments, teams, players, matches, events, organizations, users, forms and registrations.',
  resetTournamentCard: 'Reset tournament',
  resetTournamentCardDesc: 'Deletes results, matches and events. Keeps teams and players.',
  resetBtn: 'Reset',
  duplicateTournamentCard: 'Duplicate tournament',
  duplicateTournamentCardDesc: 'Copies full tournament with teams and players for a new season.',
  duplicateBtn: 'Duplicate',
  maintenanceMode: 'Maintenance mode',
  maintenanceHint: 'When enabled, public users see a "Maintenance" message instead of the app.',
  maintenanceActivated: 'ENABLED',
  maintenanceDeactivated: 'DISABLED',
  disableMaintenance: 'Disable maintenance',
  enableMaintenance: 'Enable maintenance',
  resetModalHint: 'All matches, results and events will be deleted. Teams and players will be kept with stats reset to 0.',
  copySuffix: '(copy)',
  duplicateHint: 'Teams and players will be copied. Stats reset to 0, no matches.',

  // Admin - Organizations
  cityTown: 'City / Town',

  // Admin - Dashboard
  viewTournamentsBtn: 'View tournaments',
  viewMatchesBtn: 'View matches',

  // ============================================================
  // Public marketing website
  // ============================================================

  // Web - Layout (navbar, footer)
  webDefaultDescription: 'Manage tournaments for 12 sports: football, futsal, basketball, volleyball, tennis, padel, handball, hockey, rugby, pelota and more. Online registrations, calendars, real-time standings. For towns, clubs and councils.',
  webDefaultTitleSuffix: 'Sports tournament management',
  webNavProduct: 'Product',
  webNavHome: 'Home',
  webNavPricing: 'Pricing',
  webNavGallery: 'Gallery',
  webNavContact: 'Contact',
  webNavFeatures: 'Features',
  webNavHowItWorks: 'How it works',
  webNavForOrgs: 'Who is it for',
  webNavFAQShort: 'FAQ',
  webNavFAQLong: 'Frequently asked questions',
  webNavSubFeaturesDesc: 'Everything you can do',
  webNavSubHowItWorksDesc: 'Steps to get started',
  webNavSubForOrgsDesc: 'Towns, clubs, councils',
  webNavSubFAQDesc: 'Common questions',
  webNavViewTournaments: 'View tournaments',
  webNavLoginToPanel: 'Sign in',
  webMenuAria: 'Menu',
  webFooterTagline: 'The platform to manage sports tournaments in towns, clubs and councils.',
  webFooterColProduct: 'Product',
  webFooterColResources: 'Resources',
  webFooterColLegal: 'Legal',
  webFooterLinkLiveTournaments: 'Live tournaments',
  webFooterLinkPrivacy: 'Privacy',
  webFooterLinkTerms: 'Legal notice',
  webFooterLinkCookies: 'Cookies',
  webFooterMadeIn: 'Made in Spain',

  // Web - Home
  webHomeTitle: 'Run tournaments like a pro',
  webHomeDescription: 'Manage tournaments for 12 sports: football, futsal, basketball, volleyball, tennis, padel, handball, hockey, rugby, pelota and more. Online registrations, automatic calendars, live standings. For towns, clubs and councils.',
  webHomeBadge: 'Made in Spain · 12 sports · In Spanish',
  webHomeHeroLine1: 'Run tournaments',
  webHomeHeroLine2: 'like a pro',
  webHomeHeroSubtitle: 'Teams, players, calendars, knockouts, online registrations and real-time results. For towns, clubs and councils.',
  webHomeHeroCtaPricing: 'See pricing',
  webHomeHeroCtaLive: 'Live tournaments',
  webHomeHeroDisclaimer: 'One-off setup + annual hours pack · No mandatory subscriptions',
  webHomeSectionsTitle1: 'Everything you need,',
  webHomeSectionsTitle2: 'in one place',
  webHomeCardFeaturesTitle: 'Features',
  webHomeCardFeaturesDesc: 'Everything you can do with TorneosPro',
  webHomeCardHowItWorksTitle: 'How it works',
  webHomeCardHowItWorksDesc: '3 simple steps to get started',
  webHomeCardForOrgsTitle: 'Who is it for',
  webHomeCardForOrgsDesc: 'Towns, clubs and councils',
  webHomeCardPricingTitle: 'Pricing',
  webHomeCardPricingDesc: 'One-off setup + annual hours pack',
  webHomeCardGalleryTitle: 'Gallery',
  webHomeCardGalleryDesc: 'Photos from real tournaments',
  webHomeCardFAQTitle: 'FAQ',
  webHomeCardFAQDesc: 'The most common questions',
  webHomeCardSeeMore: 'See more',
  webHomeExcelTitle1: 'Goodbye',
  webHomeExcelTitle2: 'Excel',
  webHomeExcelTitle3: 'hello',
  webHomeExcelBadColumnTitle: 'Excel / WhatsApp / paper',
  webHomeExcelBad1: 'Tracking results by hand',
  webHomeExcelBad2: 'Calculating standings manually',
  webHomeExcelBad3: 'Wrestling with formulas for tiebreakers',
  webHomeExcelBad4: 'Endless messages for every schedule change',
  webHomeExcelBad5: 'No player stats',
  webHomeExcelBad6: 'No online registrations',
  webHomeExcelGoodColumnTitle: 'With TorneosPro',
  webHomeExcelGood1: 'Live results from the sports hall',
  webHomeExcelGood2: 'Automatic standings with configurable tiebreakers',
  webHomeExcelGood3: 'Knockout brackets generated in one click',
  webHomeExcelGood4: 'Public registrations with QR and countdown',
  webHomeExcelGood5: 'Individual stats: top scorers, MVP, fair play',
  webHomeExcelGood6: 'PDF and Excel exports on the spot',
  webHomeSportsTitle1: 'Any sport,',
  webHomeSportsTitle2: 'tailored to you',
  webHomeSportsIntro1: 'Out of the box we already have',
  webHomeSportsIntro2: '12 sports',
  webHomeSportsIntro3: 'set up with their own terminology, positions and format. Need another? We add it at no extra cost for your organization.',
  webHomeSportFutsal: 'Futsal',
  webHomeSportFootball7: '7-a-side football',
  webHomeSportFootball11: '11-a-side football',
  webHomeSportBasketball: 'Basketball',
  webHomeSportVolleyball: 'Volleyball',
  webHomeSportHandball: 'Handball',
  webHomeSportPadel: 'Padel',
  webHomeSportTennis: 'Tennis',
  webHomeSportPelota: 'Pelota',
  webHomeSportRugby: 'Rugby',
  webHomeSportHockey: 'Hockey',
  webHomeSportBeachSoccer: 'Beach soccer',
  webHomeSportYours: 'Yours',
  webHomeSportNotListedPre: "Don't see your sport?",
  webHomeSportNotListedAsk: 'Ask for it',
  webHomeSportNotListedPost: "and we'll add it.",
  webHomeFinalTitle: "Let's talk about your tournament",
  webHomeFinalSubtitle: 'Tell us what you want to organize and we will prepare a tailored quote within 24 business hours.',
  webHomeFinalCtaContact: 'Contact us',
  // Hero — price hint
  webHomeHeroPriceHint: 'Custom quote · No commitment',
  // Social proof
  webHomeProofBadge: 'IN PRODUCTION',
  webHomeProofTitle: 'Built with real tournaments, not mockups',
  webHomeProofCaseLabel: 'REAL CASE',
  webHomeProofCaseTitle: 'Zarautz Summer Cup · Futsal',
  webHomeProofCaseDesc: 'Running the Zarautz summer futsal tournament for 3 years, with up to 32 teams and multiple league formats (groups + knockout, double round, mixed…). Live scoring from the sports hall and public standings shared via WhatsApp.',
  webHomeProofStatYears: 'Years',
  webHomeProofStatTeams: 'Max teams',
  webHomeProofStatLive: 'Live',
  webHomeProofSupportTitle: 'Personal support in your language',
  webHomeProofSupportDesc: 'We answer in Spanish, Basque or English. No chatbots, no week-long tickets — we reply personally.',
  webHomeProofPaymentTitle: 'One-time payment, no surprises',
  webHomeProofPaymentDesc: 'Setup paid once + an hours pack you choose. No recurring subscription that strangles you year after year.',
  // Screenshots
  webHomeScreensTitle1: 'This is what',
  webHomeScreensTitle2: 'TorneosPro looks like',
  webHomeScreensSubtitle: 'Designed to look great at the sports hall, at the town council office, and on the phone of the parent following their kid.',
  webHomeScreen1Label: 'Admin panel',
  webHomeScreen1Desc: 'Create tournaments, teams and players in minutes.',
  webHomeScreen2Label: 'Match table',
  webHomeScreen2Desc: 'Each match desk logs in with a code and sees only their assigned matches.',
  webHomeScreen3Label: 'Public page',
  webHomeScreen3Desc: 'Multi-sport, with open registrations and shareable via QR.',
  webHomeScreen4Label: 'Visual knockouts',
  webHomeScreen4Desc: 'Automatic bracket with stats, sponsors and top scorers.',
  webHomeScreen5Label: 'Live scoring',
  webHomeScreen5Desc: 'Score, attendance, goals and cards from the match desk.',

  // Web - Features
  webFeaturesTitle: 'Features',
  webFeaturesDescription: 'All TorneosPro features: unlimited tournaments, teams and players, automatic calendar, live standings, knockouts, online registrations, scoring table, stats, PDF/Excel exports and more.',
  webFeaturesBadge: 'FEATURES',
  webFeaturesHeroTitle1: 'Everything',
  webFeaturesHeroTitle2: 'you can do',
  webFeaturesHeroSubtitle: '12 key features that replace Excel, WhatsApp and a drawer full of paper.',
  webFeaturesItem1Title: 'Unlimited tournaments',
  webFeaturesItem1Desc: 'Create as many tournaments as you want: leagues, knockouts, mixed formats. Each one with its own sport, calendar and configuration.',
  webFeaturesItem2Title: 'Teams and players',
  webFeaturesItem2Desc: 'Full team management with crest, color, contact. Player roster with number, position and individual stats.',
  webFeaturesItem3Title: 'Automatic calendar',
  webFeaturesItem3Desc: 'Generate calendars in seconds: enter dates, times and available pitches. The app spreads matches across rounds.',
  webFeaturesItem4Title: 'Live standings',
  webFeaturesItem4Desc: 'Every goal updates the table. Configurable tiebreakers: points, goals, head-to-head, fair play.',
  webFeaturesItem5Title: 'Knockout bracket',
  webFeaturesItem5Desc: 'Auto-generate knockouts from the group stage. Supports extra time, penalties and automatic winner advancement.',
  webFeaturesItem6Title: 'Online registrations',
  webFeaturesItem6Desc: 'Public forms with countdown, downloadable QR, automatic waiting list and reCAPTCHA against bots.',
  webFeaturesItem7Title: 'Scoring table',
  webFeaturesItem7Desc: 'PIN-protected access so the sports hall can enter results, attendance, goals and cards live.',
  webFeaturesItem8Title: 'Detailed stats',
  webFeaturesItem8Desc: 'Top scorers, assisters, MVP and fair play rankings. Comparisons by team and round.',
  webFeaturesItem9Title: 'PDF and Excel export',
  webFeaturesItem9Desc: 'Instantly generate standings, calendar, team sheets, rosters with players. Full multi-sheet Excel.',
  webFeaturesItem10Title: '100% mobile',
  webFeaturesItem10Desc: 'Works perfectly on mobile, tablet and desktop. Installable as an app. Automatic push notifications to tournament followers are available on the Plus plan or higher.',
  webFeaturesItem11Title: 'Multi-language',
  webFeaturesItem11Desc: 'Spanish, Basque and English. Each visitor sees the app in their language with one click.',
  webFeaturesItem12Title: 'Online visibility',
  webFeaturesItem12Desc: 'Each tournament has its public URL on torneospro.com. Share via WhatsApp, social media or QR.',
  webFeaturesCtaTitle: 'Sound good?',
  webFeaturesCtaPricing: 'See pricing',
  webFeaturesCtaHowItWorks: 'How it works',

  // Web - HowItWorks
  webHowTitle: 'How it works',
  webHowDescription: '3 steps to get your first tournament running in less than a week: ask for a quote, we set everything up and you start playing. No commitment.',
  webHowBadge: 'HOW IT WORKS',
  webHowHeroTitle1: '3 steps',
  webHowHeroTitle2: 'to get started',
  webHowHeroSubtitle: 'In less than a week you can have your first tournament up and running.',
  webHowStep1Title: 'Ask us for a quote',
  webHowStep1Desc: 'Tell us what you want to organize (a festival tournament, a municipal league…) and we will prepare a tailored quote within 24 business hours. No commitment.',
  webHowStep2Title: 'We set everything up',
  webHowStep2Desc: 'Once signed, we register your organization with your logo and details. We hold 1-2 training video calls with you and your delegates. We configure your first tournament alongside you.',
  webHowStep3Title: 'Game on!',
  webHowStep3Desc: 'Share the public tournament URL or registration QR. The scoring tables enter results from the sports hall. You see everything in real time from your admin panel.',
  webHowCtaTitle: 'Ready to start?',
  webHowCtaSubtitle: 'Ask for a no-commitment quote and we reply within 24 business hours.',
  webHowCtaRequest: 'Request a quote',
  webHowCtaPricing: 'See pricing',

  // Web - ForOrgs
  webOrgsTitle: 'Who is it for',
  webOrgsDescription: 'TorneosPro is built for whoever runs amateur tournaments: town festivals, councils, companies, schools, sports clubs, associations and supporters clubs.',
  webOrgsBadge: 'WHO IS IT FOR',
  webOrgsHeroTitle1: 'Do you see yourself',
  webOrgsHeroTitle2: 'in any of these?',
  webOrgsHeroSubtitle: 'TorneosPro is designed for those who organize amateur tournaments in towns, clubs or councils.',
  webOrgsCase1Title: 'Town festivals',
  webOrgsCase1Desc: 'Festival committee in a 1,000-5,000 inhabitant town running an annual futsal tournament. Registrations via QR posted in bars.',
  webOrgsCase2Title: 'Councils',
  webOrgsCase2Desc: 'Ongoing municipal league with several sports running in parallel throughout the year. Scoring table at every sports hall.',
  webOrgsCase3Title: 'Companies',
  webOrgsCase3Desc: 'Company or inter-company tournament over the weekend. Closed registration via email with limited spots.',
  webOrgsCase4Title: 'Schools and high schools',
  webOrgsCase4Desc: 'Inter-class league or school competition. Rosters with under-age players, protected data.',
  webOrgsCase5Title: 'Sports clubs',
  webOrgsCase5Desc: 'Federated club with several categories and sections. Cadet, youth, senior and veteran teams.',
  webOrgsCase6Title: 'Associations and supporters clubs',
  webOrgsCase6Desc: 'A supporters club, parents association or cultural association running an amateur tournament once a year on key dates.',
  webOrgsCtaTitle: 'Not sure if you fit?',
  webOrgsCtaSubtitle: 'Tell us about your case and we will tell you, no strings attached, whether TorneosPro is right for you.',
  webOrgsCtaButton: 'Request a quote',

  // Web - FAQ
  webFAQTitle: 'Frequently asked questions',
  webFAQDescription: 'We answer the most common questions about TorneosPro: pricing, installation, multi-tournament management, support, data, scoring table and much more.',
  webFAQBadge: 'FAQ',
  webFAQHeroTitle1: 'Frequently',
  webFAQHeroTitle2: 'asked questions',
  webFAQQ1: 'How much does it cost?',
  webFAQA1: 'It depends on the size of your organization. You pay an initial setup and choose an annual hours pack tailored to your needs. There are no mandatory subscriptions. Tell us what you want to organize and we will prepare a quote within 24 business hours.',
  webFAQQ2: 'Do I need to install anything?',
  webFAQA2: 'No. It runs on any browser (Chrome, Safari, Firefox) on desktop, mobile or tablet. It is a Progressive Web App (PWA): you can "install it" as a shortcut on your phone if you want.',
  webFAQQ3: 'Do players need an account?',
  webFAQA3: 'No. Only you, the organizer. Players and fans access the tournament via a public link, with no signup required.',
  webFAQQ4: 'Can I run several tournaments at the same time?',
  webFAQA4: 'Yes, as many as you want. Each one with its own sport, format, teams and independent configuration.',
  webFAQQ5: 'What happens with my data?',
  webFAQA5: 'It is stored securely in Firebase (Google Cloud) with strict access rules. You can download a full backup whenever you want.',
  webFAQQ6: 'Is there technical support?',
  webFAQA6: 'Yes. You can reach us by email at info@torneospro.com and we reply within 24 business hours. Hours packs include WhatsApp/email support.',
  webFAQQ7: 'Do you accept 30 or 60-day payment terms?',
  webFAQA7: 'Yes, especially for councils and public entities with budget. We provide all the administrative documentation you need.',
  webFAQQ8: 'Can I change the tournament format after starting?',
  webFAQA8: 'Better not. If you switch from League to Knockout with matches already played, the standings will break. If you need to change, export the data first.',
  webFAQQ9: 'Can I download my tournament data?',
  webFAQA9: 'Yes, in each tournament click the "Export" button → it generates a PDF (standings, scorers, calendar, teams) and a full Excel with all sheets.',
  webFAQQ10: 'How does the scoring table work?',
  webFAQA10: 'It is a simplified panel accessed via torneospro.com/mesa with a 6-digit PIN. The user only sees their assigned matches and enters attendance, goals and cards live.',
  webFAQQ11: 'Do you have a native app?',
  webFAQA11: 'No, but the web works perfectly as an installable app (PWA). On iPhone add it from Safari → Share → Add to Home Screen.',
  webFAQQ12: 'Will I get notifications when teams register?',
  webFAQA12: 'We are wrapping up that module. For now you see the alert when entering the admin with the pending counter.',
  webFAQCtaTitle: "Don't see your question?",
  webFAQCtaButton: 'Ask us directly',

  // Web - Contact
  webContactTitle: 'Contact',
  webContactDescription: 'Tell us what you want to organize and we will prepare a tailored quote within 24 business hours. No commitment. info@torneospro.com',
  webContactBadge: 'CONTACT',
  webContactHeroTitle1: "Let's talk",
  webContactHeroTitle2: 'about your tournament',
  webContactHeroSubtitle: 'Tell us what you want to organize and we will prepare a tailored quote within 24 business hours.',
  webContactHoursLabel: 'Hours:',
  webContactHoursText: 'we reply Monday to Friday within 24 business hours. Weekends and bank holidays it may take longer.',

  // Web - 404
  web404Title: 'Page not found',
  web404Description: 'The page you are looking for does not exist or has been moved.',
  web404HeadlinePart1: 'This page has gone',
  web404HeadlinePart2: 'out of bounds',
  web404Body: 'The page you are looking for does not exist, has been moved, or the link is misspelled. No worries, we will take you back home.',
  web404CtaHome: 'Go home',
  web404CtaTournaments: 'View tournaments',
  web404SuggestionsTitle: 'Were you looking for any of these?',
  web404SuggestPricing: 'Pricing',
  web404SuggestFeatures: 'Features',
  web404SuggestGallery: 'Gallery',
  web404SuggestFAQ: 'FAQ',
  web404SuggestContact: 'Contact',

  // Public gallery
  galleryBadge: 'GALLERY',
  galleryHeroTitle1: 'The',
  galleryHeroTitleHighlight: 'best moments',
  galleryHeroTitle2: 'from tournaments',
  galleryDescription: 'Photos from real tournaments run with TorneosPro: local festivals, city leagues, corporate events and more.',
  gallerySearchPlaceholder: 'Search album by tournament or sport...',
  galleryEmptyTitle: 'No photos yet',
  galleryEmptyBody: 'We\'ll upload the best tournament moments soon.',
  galleryFeatured: 'Featured',
  galleryAlbumsTitle: 'Albums by tournament',
  galleryResultsCount: 'Results',
  galleryRotating: 'Rotating every 5s',
  galleryAlbumsTotal: 'albums total',
  galleryNoMatch: 'No albums match',
  galleryPhotos: 'photos',
  gallerySport: 'Sport',

  // Public pricing
  pricingBadgePreLaunch: 'PRE-LAUNCH',
  pricingBadgeQuote: 'Request a quote',
  pricingBadgeSuccess: 'Request received',
  pricingRequestQuote: 'Request quote',
  pricingContactUs: 'Contact us',
  pricingBuy: 'Buy plan',
  pricingSelected: 'Selected plan',
  pricingIncluded: 'Included:',
  pricingNotIncluded: 'Not included',
  pricingLimits: 'Limits',
  pricingUseCase: 'Best for:',
  pricingCta: 'Choose plan',
  pricingCtaChosen: 'Plan chosen',
  pricingQuoteThanks: 'Request received. We\'ll get in touch soon.',
  pricingQuoteError: 'Could not send request'
};
